import { Link } from "react-router-dom";

export default function SecondLevelDropdownItem({ navItemText, path }) {
	return (
		<li className="sub-menu--item">
			<Link to={path}>{navItemText}</Link>
		</li>
	);
}
